import React, { CSSProperties, useEffect, useState } from 'react';

import { t } from 'i18next';

import { TaskFragment } from '@school_ify/schoolify-repository/src/shared/types';
import { useUpdateMyTaskMutation } from '@school_ify/schoolify-repository/src/student_teacher/types';

import TextField from 'clean/components/common/TextField/TextField';
import ModalDialog from 'components/ModalDialog/ModalDialog';

import './EditMyTask.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  openModal?: boolean;
  onClose?: () => void;
  task?: TaskFragment;
}

const EditMyTaskModal: React.FC<Props> = ({ openModal, onClose, task }) => {
  const [editTask, setEditTask] = useState<TaskFragment>(null);
  const [updateMyTaskMutation, { error }] = useUpdateMyTaskMutation();

  useEffect(() => {
    setEditTask(task);
  }, [task]);

  function handleUpdateTask() {
    if (editTask) {
      delete editTask['__typename'];
      updateMyTaskMutation({
        variables: {
          id: editTask.id,
          task: editTask,
        },
      });
    }
    onClose();
  }

  function setTaskProp(e, prop) {
    const copyTask = { ...editTask };
    copyTask[prop] = e;
    setEditTask(copyTask);
  }

  return (
    <ModalDialog
      open={openModal}
      onClose={onClose}
      actions={[
        {
          type: 'filled',
          colour: 'primary',
          label: t('common:edit_task'),
          handler: handleUpdateTask,
          fullWidth: true,
        },
      ]}
    >
      <div className="add-task-popover">
        <div className="title-input-container">
          <TextField
            onChange={e => setTaskProp(e.target.value, 'title')}
            value={editTask?.title}
            placeholder={t('study:title').toString().replace('*', '')}
          />
        </div>
        <div className="divider" />

        <div className="text-area-container">
          <textarea
            style={{ width: '100%' }}
            onChange={e => setTaskProp(e.target.value, 'body')}
            placeholder={t('common:add_a_custom_task')}
            value={editTask?.body}
            rows={6}
          />
          {error && <p>{error.message}</p>}
        </div>
      </div>
    </ModalDialog>
  );
};

export default EditMyTaskModal;
